import { css } from 'lit';

export const style = css`
  .step-communication-v2-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .next-button {
    width: 100%;
  }

  @media (min-width: 542px) {
    .compact-dob-ssn {
      display: grid;
      gap: 1rem;
      grid-template-columns: 1fr 1fr;
      margin-top: -1rem;
    }
  }
`;
